import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import PostForm from "./PostForm";

function PostFormDialog({
  open,
  onClose,
  onSubmit,
  onDelete,
  initial,
  submitLabel = "Gem",
  formKey,
  postUuid,
  recipeUuid,
  postType = "post",
  hideTemplate = false,
  title,
}) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      fullScreen={fullScreen}
      maxWidth="md"
      scroll="paper"
      PaperProps={{
        sx: {
          height: fullScreen ? "100%" : "min(90vh, 860px)",
          m: fullScreen ? 0 : 2,
          borderRadius: fullScreen ? 0 : 2,
          position: "relative",
        },
      }}
    >
      <IconButton
        aria-label="Luk"
        onClick={onClose}
        sx={{
          position: "absolute",
          top: 8,
          right: 8,
          zIndex: 1,
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          pt: { xs: 5, sm: 4 },
          pb: 2,
        }}
      >
        {open ? (
          <PostForm
            key={formKey || initial?.post_uuid || initial?.recipe_uuid || initial?.body || "new"}
            initial={initial}
            onSubmit={onSubmit}
            onCancel={onClose}
            onDelete={onDelete}
            submitLabel={submitLabel}
            postUuid={postUuid}
            recipeUuid={recipeUuid}
            postType={postType}
            hideTemplate={hideTemplate || postType === "recipe"}
          />
        ) : null}
      </DialogContent>
    </Dialog>
  );
}

export default PostFormDialog;
